import { render, staticRenderFns } from "./GenericBoxHeader.vue?vue&type=template&id=24893818&scoped=true"
import script from "./GenericBoxHeader.vue?vue&type=script&lang=js"
export * from "./GenericBoxHeader.vue?vue&type=script&lang=js"
import style0 from "./GenericBoxHeader.vue?vue&type=style&index=0&id=24893818&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24893818",
  null
  
)

export default component.exports